<template>
  <div id="documents" class="documents">
    <div class="file-table">
      <div>
        <table class="left-table">
          <tr>
            <td><span class="division-line">EVENT</span></td>
            <td><span class="division-line">STATUS</span></td>
            <td><span class="division-line">ESTIMATED DATE</span></td>
            <td><span class="division-line">ACTUAL DATE</span></td>
          </tr>
          <tr v-for="(item,index) in list" :key="index">
            <td>{{ item.descriptionEn }}</td>
            <td><span class="blue">{{ item.statusWeb }}</span></td>
            <td>{{ item.estimatedDateStr }}</td>
            <td>{{ item.dateStr }}</td>
          </tr>
        </table>
      </div>
      <div>
        <table class="right-table">
          <tr>
            <td><span class="division-line">BOOKING DETAILS</span></td>
          </tr>
          <tr>
            <td>Tracking:{{ data.trackingNo }}</td>
          </tr>
          <tr>
            <td>Carrier:{{ data.modeCodePage }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { GetOrderTrack } from '@/api/order.js'
export default {
  name: 'Documents',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      list: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {

  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
	  GetOrderTrack({ orderNo: data.orderNo }).then(res => {
        if (res.code == 200) {
          this.list = res.data.list
        }
	  })
    }
  }
}
</script>
<style scoped lang='scss'>
	.documents {
		padding: 8px 24px 8px 32px;
		.file-table {
			display: flex;
			.left-table {
				border: 1px solid rgba(221, 221, 221, 0.56);
				border-radius: 8px;
				width: 800px;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;
				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);
						width: 200px;
					}
				}
				tr {
					height: 40px;
					td {
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}

			.right-table {
				vertical-align: inherit!important;
				margin-left: 15px;
				border: 1px solid rgba(221, 221, 221, 0.56);
				border-radius: 8px;
				width: 322px;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;
				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);
						width: 200px;
					}
				}
				tr {
					td {
						height: 40px;
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;
						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}
						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}
		}

		.add-button {
			text-align: right;

			button {
				width: 200px;
				height: 32px;
				background: rgba(2, 127, 252, 0);
				border-radius: 8px;
				border: 1px solid rgba(2, 127, 252, 0.4);
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				margin: 8px 0px 16px 0;

				span {
					margin-right: 4px;
				}
			}
		}

		.documents-title {
			text-align: left;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			margin-bottom: 8px;

			span:nth-of-type(1) {
				font-weight: 500;
				color: #333333;
			}

			span:nth-of-type(2) {
				font-weight: 400;
				color: #777777;
			}
		}
	}
</style>
